import state from "./state";
import actions from "./actions";
import mutations from "./mutations";

const getters = {
  getEmployeeYearlyAttendanceExportList: (state) => state.items,
  getEmployeeYearlyAttendanceExportListPagination: (state) => state.pagination,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
